var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarSwLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 122.391,
    height: 73.42,
    viewBox: "0 0 122.391 73.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 122.391,
    height: 73.42,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    transform: "translate(-15.5 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(15.5 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M9.493,77.73q.3,0,.3.327V79.47q0,.327-.3.327H2.766a.631.631,0,0,0-.55.223,1.015,1.015,0,0,0-.161.609v.506q0,.832.7.833H7.787a2.238,2.238,0,0,1,1.759.662,2.757,2.757,0,0,1,.591,1.9v1.19a2.6,2.6,0,0,1-.578,1.755,2.251,2.251,0,0,1-1.8.669H.322c-.206,0-.308-.108-.308-.327V86.4c0-.218.1-.327.308-.327H7.371a.633.633,0,0,0,.55-.224,1.021,1.021,0,0,0,.161-.61V84.63q0-.832-.7-.833H2.35a2.237,2.237,0,0,1-1.759-.662A2.754,2.754,0,0,1,0,81.24V80.154A2.592,2.592,0,0,1,.577,78.4a2.251,2.251,0,0,1,1.8-.669Z",
    transform: "translate(0 -18.007)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M23.556,80.653a.176.176,0,0,1,.183.111.332.332,0,0,1-.018.26l-4.86,10.069a1.658,1.658,0,0,1-.715.766,2.771,2.771,0,0,1-1.285.245h-.886q-.227,0-.227-.268V90.617q0-.267.227-.267h.747a.644.644,0,0,0,.645-.342l.684-1.413a.845.845,0,0,1-.487-.178,1.434,1.434,0,0,1-.323-.461l-3.418-6.931a.332.332,0,0,1-.018-.26.176.176,0,0,1,.183-.111h1.456a.309.309,0,0,1,.3.208l2.81,5.726a1.518,1.518,0,0,0,.158.275.184.184,0,0,0,.146.067l2.974-6.068a.308.308,0,0,1,.3-.208Z",
    transform: "translate(-3.194 -18.684)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M37.207,80.653a5.711,5.711,0,0,1,1.511.171,2.269,2.269,0,0,1,.987.536,2,2,0,0,1,.53.937,5.3,5.3,0,0,1,.154,1.375V88.49c0,.219-.1.327-.3.327H38.777c-.2,0-.3-.108-.3-.327V84.177a4.771,4.771,0,0,0-.054-.781,1.089,1.089,0,0,0-.2-.506.819.819,0,0,0-.416-.267,2.509,2.509,0,0,0-.711-.082H34.736V88.49c0,.219-.1.327-.308.327H33.112c-.2,0-.3-.108-.3-.327V82.542H30.534a2.606,2.606,0,0,0-.712.082.948.948,0,0,0-.449.267,1.054,1.054,0,0,0-.234.506,3.82,3.82,0,0,0-.068.781V88.49c0,.219-.1.327-.3.327H27.459c-.206,0-.309-.108-.309-.327V83.672a5.118,5.118,0,0,1,.161-1.375,2.077,2.077,0,0,1,.53-.937,2.215,2.215,0,0,1,.98-.536,5.764,5.764,0,0,1,1.524-.171Z",
    transform: "translate(-6.29 -18.684)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M48.119,76.762c.2,0,.3.109.3.327v2.662H53.45a5.786,5.786,0,0,1,1.517.171,2.226,2.226,0,0,1,.987.536,2.084,2.084,0,0,1,.53.937,5.118,5.118,0,0,1,.161,1.375v2.141a5.124,5.124,0,0,1-.161,1.376,2.077,2.077,0,0,1-.53.937,2.159,2.159,0,0,1-.987.529,6.023,6.023,0,0,1-1.517.163H49.691a6.006,6.006,0,0,1-1.524-.163,2.149,2.149,0,0,1-.98-.529,2.063,2.063,0,0,1-.53-.937,5.125,5.125,0,0,1-.161-1.376V77.089c0-.218.1-.327.309-.327Zm.3,4.774V84.5a3.857,3.857,0,0,0,.067.788,1.056,1.056,0,0,0,.235.5.941.941,0,0,0,.449.267,2.6,2.6,0,0,0,.711.082h3.384a2.662,2.662,0,0,0,.725-.082.948.948,0,0,0,.449-.267,1.056,1.056,0,0,0,.235-.5,3.851,3.851,0,0,0,.068-.788V83.172a3.875,3.875,0,0,0-.068-.781,1.064,1.064,0,0,0-.235-.506.948.948,0,0,0-.449-.267,2.662,2.662,0,0,0-.725-.082Z",
    transform: "translate(-10.771 -17.783)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M68.606,80.653a5.787,5.787,0,0,1,1.517.171,2.218,2.218,0,0,1,.987.536,2.084,2.084,0,0,1,.53.937,5.117,5.117,0,0,1,.161,1.375v2.141a5.124,5.124,0,0,1-.161,1.376,2.077,2.077,0,0,1-.53.937,2.151,2.151,0,0,1-.987.529,6.022,6.022,0,0,1-1.517.163h-3.8a6,6,0,0,1-1.524-.163,2.152,2.152,0,0,1-.98-.529,2.077,2.077,0,0,1-.53-.937,5.127,5.127,0,0,1-.161-1.376V83.672a5.121,5.121,0,0,1,.161-1.375,2.084,2.084,0,0,1,.53-.937,2.22,2.22,0,0,1,.98-.536,5.764,5.764,0,0,1,1.524-.171ZM63.53,85.441a3.8,3.8,0,0,0,.068.788,1.056,1.056,0,0,0,.235.5.952.952,0,0,0,.449.268,2.634,2.634,0,0,0,.711.081h3.424A2.7,2.7,0,0,0,69.143,87a.956.956,0,0,0,.449-.268,1.056,1.056,0,0,0,.235-.5,3.85,3.85,0,0,0,.068-.788V84.029a3.77,3.77,0,0,0-.068-.774,1.109,1.109,0,0,0-.235-.506.875.875,0,0,0-.449-.267,2.9,2.9,0,0,0-.725-.075H64.994a2.833,2.833,0,0,0-.711.075.872.872,0,0,0-.449.267,1.109,1.109,0,0,0-.235.506,3.718,3.718,0,0,0-.068.774Z",
    transform: "translate(-14.273 -18.684)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M77.387,79.962V78c0-.218.1-.327.3-.327h1.329q.3,0,.3.327v1.963h2.35q.241,0,.241.267v1.22c0,.177-.081.267-.241.267h-2.35v3.451a1.478,1.478,0,0,0,.228.914,1.108,1.108,0,0,0,.9.29h1.3c.161,0,.241.09.241.267v1.22q0,.267-.241.267H80.113a4.539,4.539,0,0,1-1.329-.163,1.818,1.818,0,0,1-.839-.521,1.993,1.993,0,0,1-.436-.922,6.555,6.555,0,0,1-.121-1.353V81.717H76.112c-.161,0-.242-.09-.242-.267V80.23q0-.267.242-.267Z",
    transform: "translate(-17.576 -17.993)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M86.861,76.724c.2,0,.3.108.3.327v1.413q0,.342-.3.342H85.546c-.207,0-.309-.114-.309-.342V77.051c0-.218.1-.327.309-.327Zm0,3.019q.3,0,.3.342v7.5c0,.219-.1.327-.3.327H85.546c-.2,0-.3-.108-.3-.327v-7.5q0-.342.3-.342Z",
    transform: "translate(-19.746 -17.774)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M98.128,80.653c.161,0,.241.089.241.267V82.17c0,.179-.08.268-.241.268H92.919a2.665,2.665,0,0,0-.725.081.9.9,0,0,0-.443.268,1.1,1.1,0,0,0-.228.506,3.881,3.881,0,0,0-.067.781V85.4a3.86,3.86,0,0,0,.067.788,1.09,1.09,0,0,0,.228.5.9.9,0,0,0,.443.268,2.665,2.665,0,0,0,.725.081h5.209c.161,0,.241.09.241.268V88.55c0,.178-.08.267-.241.267h-5.4a5.994,5.994,0,0,1-1.524-.163,2.162,2.162,0,0,1-.98-.529,2.074,2.074,0,0,1-.53-.937,5.122,5.122,0,0,1-.161-1.375V83.672A5.118,5.118,0,0,1,89.7,82.3a2.077,2.077,0,0,1,.53-.937,2.215,2.215,0,0,1,.98-.536,5.76,5.76,0,0,1,1.524-.171Z",
    transform: "translate(-20.742 -18.684)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M103.647,80.653a.3.3,0,0,1,.309.237L105.687,87a.14.14,0,0,0,.134.1h.054c.081,0,.125-.035.134-.1l1.813-5.637a1.258,1.258,0,0,1,.316-.558.816.816,0,0,1,.543-.156h1.6a.815.815,0,0,1,.543.156,1.273,1.273,0,0,1,.316.558l1.8,5.637c.009.069.055.1.134.1h.054a.14.14,0,0,0,.134-.1l1.746-6.113a.272.272,0,0,1,.309-.237h1.517c.117,0,.191.032.222.1a.389.389,0,0,1,.006.26L115.019,87.9a1.482,1.482,0,0,1-.383.744,1.018,1.018,0,0,1-.651.178h-1.692a.7.7,0,0,1-.537-.2,2.044,2.044,0,0,1-.363-.721l-1.773-5.428a.115.115,0,0,0-.121-.089h-.081c-.071,0-.111.03-.121.089L107.541,87.9a2.058,2.058,0,0,1-.363.721.7.7,0,0,1-.537.2h-1.692a1.017,1.017,0,0,1-.651-.178,1.482,1.482,0,0,1-.383-.744L101.9,81.009a.433.433,0,0,1,0-.26c.027-.065.1-.1.229-.1Z",
    transform: "translate(-23.602 -18.684)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M128.749,80.653a5.786,5.786,0,0,1,1.517.171,2.218,2.218,0,0,1,.987.536,2.077,2.077,0,0,1,.53.937,5.114,5.114,0,0,1,.161,1.375v3.956a3.007,3.007,0,0,1-.047.587.8.8,0,0,1-.161.365.592.592,0,0,1-.3.185,1.824,1.824,0,0,1-.483.053H124.56a3.284,3.284,0,0,1-.987-.127,1.491,1.491,0,0,1-.638-.38,1.421,1.421,0,0,1-.342-.654,3.967,3.967,0,0,1-.1-.952v-.714a3.11,3.11,0,0,1,.1-.825,1.425,1.425,0,0,1,.342-.618,1.489,1.489,0,0,1,.638-.379,3.284,3.284,0,0,1,.987-.127h5.464v-.283a2.41,2.41,0,0,0-.067-.609.873.873,0,0,0-.228-.409.976.976,0,0,0-.443-.23,2.9,2.9,0,0,0-.725-.075h-5.612c-.161,0-.242-.088-.242-.267V80.921q0-.269.242-.268Zm.887,6.529a.362.362,0,0,0,.3-.111.665.665,0,0,0,.087-.394V85.368h-4.913a.76.76,0,0,0-.585.186.781.781,0,0,0-.167.542v.313a.857.857,0,0,0,.167.587.76.76,0,0,0,.585.186Z",
    transform: "translate(-28.377 -18.684)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M143.567,80.653q.242,0,.242.267V82.17q0,.269-.242.268H140a2.6,2.6,0,0,0-.712.081.942.942,0,0,0-.449.268,1.057,1.057,0,0,0-.234.506,3.821,3.821,0,0,0-.068.781V88.49c0,.219-.1.327-.3.327h-1.316c-.206,0-.309-.108-.309-.327V83.672a5.118,5.118,0,0,1,.161-1.375,2.077,2.077,0,0,1,.53-.937,2.215,2.215,0,0,1,.98-.536,5.76,5.76,0,0,1,1.524-.171Z",
    transform: "translate(-31.648 -18.684)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M154.121,80.653a4.307,4.307,0,0,1,1.135.126,1.471,1.471,0,0,1,.711.416,1.672,1.672,0,0,1,.37.758,5.193,5.193,0,0,1,.107,1.139V84.5a.922.922,0,0,1-.187.662.794.794,0,0,1-.577.186H148.9v.357a1.418,1.418,0,0,0,.3,1.011,1.646,1.646,0,0,0,1.175.312h5.6c.161,0,.241.09.241.268V88.55c0,.178-.08.268-.241.268h-5.787a6,6,0,0,1-1.524-.164,2.156,2.156,0,0,1-.98-.529,2.07,2.07,0,0,1-.53-.937,5.123,5.123,0,0,1-.161-1.375V83.672a5.115,5.115,0,0,1,.161-1.375,2.077,2.077,0,0,1,.53-.937,2.217,2.217,0,0,1,.98-.536,5.77,5.77,0,0,1,1.524-.171ZM148.9,84.029h5.438q.228,0,.228-.254v-.624a.975.975,0,0,0-.174-.655.85.85,0,0,0-.645-.194h-3.37a1.676,1.676,0,0,0-1.175.305,1.416,1.416,0,0,0-.3,1.019Z",
    transform: "translate(-34.053 -18.684)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M81.293,23.429l14.942,8.812v11.2l-14.942-8.92Z",
    transform: "translate(-18.833 -5.427)",
    fill: "#868a8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M69.687,60.135V49.148L93.546,34.9V46.1Z",
    transform: "translate(-16.144 -8.084)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M57.761,18.265h0v0Z",
    transform: "translate(-13.381 -4.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M81.62,0,57.762,14.034l9.381,5.6L81.62,10.987Z",
    transform: "translate(-13.381 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M57.761,18.265",
    transform: "translate(-13.381 -4.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M72.7,39.97v-11.1l-5.56-3.319-9.382,5.6Z",
    transform: "translate(-13.381 -5.92)",
    fill: "#85888a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M57.761,18.265v11.2l9.381-5.6Z",
    transform: "translate(-13.381 -4.231)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarSwLogo);
export default __webpack_public_path__ + "static/media/sidebar-sw-logo.15669531ae856cbff51e9608a1e2e132.svg";
export { ForwardRef as ReactComponent };